export const baseUrl = '/portfolio';
export const gameProjectUrl = '/portfolio/game_projects';
export const webProjectUrl = '/portfolio/web_projects';


